export const CURATED_QUIZZES = {
  "taylor-swift": {
    playlistID: "5DyMJs4ZF7pVTq6hr5rGsv",
    title: "Taylor Swift's Best",
    scoreboardName: "Taylor Swift's Best",
    backgroundImage:
      "https://i.pinimg.com/736x/1e/6c/b2/1e6cb21c9ad8fd5d1b135662e34984b3.jpg",
    descriptionCards: [
      "How well do you know Taylor's Top Hits?",
      "You get a limited amount of time to guess the track",
      "Think you'll ace this? Select a difficulty to get started!",
    ],
  },
  queen: {
    playlistID: "4TzXhSlf3vy4XZCepQkx99",
    title: "This is Queen",
    scoreboardName: "This is Queen",
    backgroundImage: "https://images3.alphacoders.com/151/151767.jpg",
    descriptionCards: [
      "Did you know: Queen have sold an estimated total of 250-300 million records worldwide",
      "You get a limited amount of time to guess the track, select a difficulty to get started",
      "Queen's peak popularity was primarily during the late 1970s and early 1980s.",
    ],
  },
  "michael-jackson": {
    playlistID: "19Bv1Xkk7tRZ45QYp0BHdw",
    title: "Michael Jackson's Top Hits",
    scoreboardName: "Michael Jackson's Top Hits",
    backgroundImage:
      "https://i.pinimg.com/736x/e8/93/5a/e8935a2ad3f83ee09ce6965a65960235.jpg",
    descriptionCards: [
      "Michael Jackson is one of the best-selling music artists of all time, with sales of over 500 million records worldwide",
      "You get a limited amount of time to guess the track, select a difficulty to get started",
      "Jackson's music videos revolutionized the music industry and popularized the music video format",
    ],
  },
  "80s-mix": {
    playlistID: "1gOmmbE7DZKC2rwT8NiZsi",
    title: "80s Mix",
    scoreboardName: "80s Mix",
    backgroundImage:
      "https://i.pinimg.com/736x/c2/57/63/c2576387d993b4b5e7cf3f8effaf70ca.jpg",
    descriptionCards: [
      "The launch of MTV in 1981 revolutionized the music industry, popularizing music videos and creating a new visual language for music",
      "You get a limited amount of time to guess the track, select a difficulty to get started",
      "The ubiquitous use of synthesizers created iconic sounds, from the dreamy pads of synth-pop to the aggressive leads of electronic rock",
    ],
  },
  "70s-mix": {
    playlistID: "6hoDexBZBJnlltgv91hM6U",
    title: "70s Mix",
    scoreboardName: "70s Mix",
    backgroundImage:
      "https://i.pinimg.com/736x/a0/46/6f/a0466f5173c5909f9a0d49383456d6cb.jpg",
    descriptionCards: [
      "The 1970s was a decade of incredible musical diversity that pushed boundaries and influenced future generations",
      "You get a limited amount of time to guess the track, select a difficulty to get started",
      "Music festivals like Woodstock and Glastonbury became iconic events, bringing together massive crowds",
    ],
  },
  "top-50-global": {
    playlistID: "2eeijnQ6uPptmB9BP9xClO",
    title: "Top 50 Global",
    scoreboardName: "Top 50 Global",
    backgroundImage:
      "https://images.unsplash.com/photo-1571435763834-4d6fbb550bb7?q=80&w=2676&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    descriptionCards: [
      "This week's top hits, can you guess them?",
      "You get a limited amount of time to guess the track",
      "This one contains music from different languages, get ready!",
    ],
  },
  "rap-hits": {
    playlistID: "22U3rmQb3tZ4QTj6Dp51vs",
    title: "Most Streamed Rap Songs",
    scoreboardName: "Most Streamed Rap Songs",
    backgroundImage:
      "https://wallpapers.com/images/high/rap-computer-2666-x-1500-7wac7qhg10d865eq.webp",
    descriptionCards: [
      "Rap has become the most popular music genre on streaming platforms like Spotify",
      "You get a limited amount of time to guess the track, select a difficulty to get started",
      "The streaming era has disrupted the traditional music industry model, leading to it being the primary income",
    ],
  },
  "rock-classics": {
    playlistID: "1mewawYZH67IvzttbpgpdP",
    title: "Rock Classics",
    scoreboardName: "Rock Classics",
    backgroundImage:
      "https://i.pinimg.com/736x/04/ef/20/04ef201221bdc04b4aa841350ac92fc0.jpg",
    descriptionCards: [
      "Classic rock continues to be popular today, with many bands still touring and releasing",
      "You get a limited amount of time to guess the track, select a difficulty to get started",
      "Its influence can be heard in various modern genres, from alternative rock to metal",
    ],
  },
  "soft-pop": {
    playlistID: "1q3ZVaRMSiyPRakJb714JK",
    title: "Soft Pop Hits",
    scoreboardName: "Soft Pop Hits",
    backgroundImage:
      "https://i.pinimg.com/736x/62/cc/76/62cc7630b30c099ba122df237791206c.jpg",
    descriptionCards: [
      "Classic rock continues to be popular today, with many bands still touring and releasing",
      "You get a limited amount of time to guess the track, select a difficulty to get started",
      "Its influence can be heard in various modern genres, from alternative rock to metal",
    ],
  },
};
